import { createContext, useContext } from 'react'
import type {
  OgsmBoardNode,
  OgsmSession,
  UpdateOgsmNodeInput,
} from '@/types/api'

/**
 * What every editable piece of the board needs, so the rows and cells do not
 * thread the company, the session and the save function through each level.
 * Whether an edit is allowed is read from `session`, never worked out here.
 */
export interface BoardEdit {
  companyId: string
  session: OgsmSession
  saveNode: (nodeId: string, input: UpdateOgsmNodeInput) => void
  /** The reason the last save of this node failed, or null. */
  errorFor: (nodeId: string) => string | null
  /** Opens the objective dialog in edit mode for this node. */
  editNode: (node: OgsmBoardNode) => void
}

export const BoardEditContext = createContext<BoardEdit | null>(null)

export function useBoardEdit(): BoardEdit {
  const edit = useContext(BoardEditContext)
  if (!edit) throw new Error('useBoardEdit needs an OGSM board around it')
  return edit
}
